import { atom, createStore } from 'jotai'
import { Consultation_Slot } from '../generated/urql.anonymous'
import { Collection_Slot } from '../generated/urql.client'
import { WithOptional } from '../lib/types'
import { Message } from '../lib/messages'

export type SelectSlotModalData = {
  isOpen: boolean
  consultationId?: number
  slotId?: number
  minDate?: string
  onSelect?: (slot: WithOptional<Consultation_Slot, 'consultationId'>) => void
}

export type SelectCollectionSlotModalData = {
  isOpen: boolean
  collectionPointId?: number
  slotId?: number
  minDate?: string
  onSelect?: (slot: Pick<Collection_Slot, 'id' | 'dateFrom' | 'dateTo' | 'collectionPointId'>) => void
}

export const selectSlotModalDataAtom = atom<SelectSlotModalData>({
  isOpen: false,
})

export const selectCollectionSlotModalDataAtom =
  atom<SelectCollectionSlotModalData>({
    isOpen: false,
  })

export const messagesAtom = atom<Message[]>([])

export const store = createStore()
